import axios from "axios";
import baseService from "../base-service";

const endPointBaseURL = `ProcessContent`;

// const generateConsultationNote = async (
//   instruction: string,
//   transcript: string
// ) =>
//   axios.post(
//     `${env.REACT_APP_API_BASE_URL}/ProcessContent/GenerateConsultationNote`,
//     {
//       instruction: instruction,
//       transcript: transcript,
//     }
//   );

  const generateConsultationNote = async (
    instruction: string,
    transcript: string
  ) =>
    baseService.post(
      `/${endPointBaseURL}/GenerateConsultationNote`,
      {
        instruction: instruction,
        transcript: transcript,
      }
    );

const generateSOAPNote = async (instruction: string, transcript: string) =>
  axios.post(`/${endPointBaseURL}/GenerateSOAPNote`, {
    instruction: instruction,
    transcript: transcript,
  });

export { generateConsultationNote, generateSOAPNote };
